import type { FormEvent } from "react";
import type { FormikErrors, FormikTouched } from "formik";
import { DEFAULT_FORM_SAVE_ERROR_TOAST_MESSAGE } from "../form/fieldValidationVisibility";
import { showToastError } from "../helpers/toastUtils";

/**
 * Validates before submit: toast + touch all fields on failure, then delegates to Formik handleSubmit when valid.
 */
export function createEditFormSubmitHandler<T extends object>(
  validateForm: () => Promise<FormikErrors<T>>,
  setTouched: (
    touched: FormikTouched<T>,
    shouldValidate?: boolean
  ) => Promise<void | FormikErrors<T>>,
  values: T,
  handleSubmit: (e?: FormEvent<HTMLFormElement>) => void
) {
  return (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    void validateForm().then((errors) => {
      if (Object.keys(errors).length > 0) {
        showToastError(DEFAULT_FORM_SAVE_ERROR_TOAST_MESSAGE);
        void setTouched(
          Object.fromEntries(Object.keys(values).map((key) => [key, true])) as FormikTouched<T>
        );
        return;
      }
      handleSubmit(e);
    });
  };
}
